module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "s-tool-bar"
  }, [_c('div', {
    staticClass: "box"
  }, [(_vm.navData.length) ? _c('el-breadcrumb', {
    staticClass: "s-breadcrumb breadcrumb-bar",
    attrs: {
      "separator-class": "el-icon-arrow-left"
    }
  }, _vm._l((_vm.navData), function(item, index) {
    return _c('el-breadcrumb-item', {
      key: index
    }, [(index === _vm.navData.length - 1) ? _c('span', [_vm._v(_vm._s(item))]) : _c('a', {
      on: {
        "click": function($event) {
          index === 0 &&
            _vm.conf[item] &&
            !['order', 'billing', 'invoice', 'shipment'].includes(_vm.source) ?
            _vm.$router.replace(_vm.conf[item]) :
            _vm.$router.go(index - (_vm.navData.length - 1))
        }
      }
    }, [_vm._v(_vm._s(item))])])
  }), 1) : _vm._e(), _vm._v(" "), _vm._t("tools")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4903b5df"}!./~/vue-loader/lib/selector.js?type=template&index=0!./packages/breadBar/index.vue
// module id = 1426
// module chunks = 116